import _ from 'lodash';
import { DateTime } from 'luxon';

const auditLogUtils = {

  parseResourceName(name, output) {
    /**
     * so, thinking we should utility-ize parsing strings for resource names
     * for example, we always use:
     * kebab for urls
     * camel for variable names
     * capitalized camel for model name
     * 
     * anything else?
     */

    // console.log("test get names", output)
    if(output == "url") {
      return _.kebabCase(name)
    } else if(output == "variable") {
      return _.camelCase(name)
    } else if(output == "model") {
      return _.camelCase(name).charAt(0).toUpperCase() + _.camelCase(name).slice(1);
    }
  }

  , findObjDiffFields(a, b) {
    // returns the names of the fields that have changed
    // https://stackoverflow.com/questions/31683075/how-to-do-a-deep-comparison-between-2-objects-with-lodash/46003894#46003894
    // TODO: does this work for nested? do we care?
    return _.reduce(a, (result, value, key) => {
      return _.isEqual(value, b[key]) ?
        result : result.concat(key);
    }, []);
  }
}

export default auditLogUtils;


// WEBPACK FOOTER //
// global/utils/auditLogUtils.js